import React from 'react';

class IndexSettlement extends React.Component {

  constructor(props) {
    super(props);

    this.initialState = {
      year: this.props.initialYear,
      month: 1,
      type: this.props.type

    }
    this.state = this.initialState;

    this.now = new Date();
    this.nowPlusMonth = (new Date()).setMonth( this.now.getMonth() + 1 );

    this.months = [];

    this.onChange = this.onChange.bind(this);
    this.sendSettlement = this.sendSettlement.bind(this);
  }

  componentDidMount() {
    for (let i = 1; i <= 12; i++) {
      this.months.push(i);
    }
    this.setState({
      year: this.props.years[0]
    });
  }

  onChange(e) {
    let value = e.target.value,
      name = e.target.name;

    this.setState({
      [name]: value
    });
  }

  getMonthName(monthIndex) {
    this.now.setMonth(monthIndex - 1);
    return this.now.toLocaleString('en-us', { month: 'long' });
  }

  renderMonthOption(item) {
    const nextMonth = new Date(this.nowPlusMonth).getMonth();
    const notVisible = +this.state.year === this.now.getFullYear() && 
      nextMonth != 0 && +item > nextMonth;

    if (!notVisible)
      return <option key={'month_' + item} value={item}>{this.getMonthName(item)}</option>
  }

  sendSettlement() {
    let { marketId, sendSettlement, type } = this.props,
      { year, month } = this.state;

    sendSettlement({
      year: +year,
      month: +month,
      market_id: +marketId
    });
  }

  render() {

    let { dates } = this.props,
      isReport = this.props.type === 'report';
    return (
      <div className='indexSettlement_holder'>
        <div className='label'>{isReport ? 'Send settlement report to my email' : 'Send index report to my email'}:</div>
        <select onChange={this.onChange} name='year' value={this.state.year}>
          {this.props.years.map(item =>
            <option key={'year_' + item} value={item}>{item}</option>
          )}
        </select>
        <select onChange={this.onChange} name='month' value={this.state.month}>
          {this.months.map(item => this.renderMonthOption(item))}
        </select>
        <button className='request_indexSettlement' onClick={this.sendSettlement}>Send</button>
      </div>
    )
  }
}

export default IndexSettlement;



// WEBPACK FOOTER //
// ./source/components/indexSettlement.js